import * as React from 'react'
import { styled } from 'next-yak'

import { transition, useTransition } from '../behaviours/transition'
import * as glyphs from '../icons/glyphs/index'

import * as S from '../styles'

export type DeprecatedModalProps = {
  children: React.ReactNode
  className?: string
  closable?: boolean
  lockScroll?: boolean
  onClose?: () => void
  open: boolean
}

const SmallWrapper = transition.fromTop(S.modal.SmallWrapper)

type SmallModalProps = DeprecatedModalProps & {
  title: React.ReactNode
}

export function SmallModalComponent({
  children,
  className,
  closable,
  onClose,
  open,
  title,
}: SmallModalProps): React.ReactElement<SmallModalProps> | null {
  const { step, unmounted, onTransitionEnd } = useTransition(open)

  if (unmounted) {
    return null
  }

  return (
    <SmallWrapper className={className} step={step} onTransitionEnd={onTransitionEnd}>
      <S.modal.Title>{title}</S.modal.Title>
      {closable && <glyphs.stroke.Close size={14} onClick={onClose} />}
      <S.modal.Body>{children}</S.modal.Body>
    </SmallWrapper>
  )
}

export const SmallModal = styled(SmallModalComponent)<SmallModalProps>``
SmallModal.displayName = 'SmallModal'
